import {
	AppCacheActions,
	AppCacheState,
	CacheKey,
	useAppCacheStore,
} from "@/common/stores/persistingStores/app";
import { useCallback } from "react";

export const useResizeHook = (
	cacheKey: CacheKey,
	defaultWidth: number
): [
	interactionPanelWidth: number,
	onResizeStop: (
		_event: any,
		_direction: any,
		_refToElement: any,
		_delta: any
	) => void,
] => {
	const appStoreCache = useAppCacheStore((state: AppCacheState) => state.cache);
	const appStoreActions = useAppCacheStore((state: AppCacheActions) => state);

	const panelWidth = appStoreCache[cacheKey] || defaultWidth;

	const onResizeStop = useCallback(
		(_event: any, _direction: any, _refToElement: any, _delta: any) => {
			
			let newWidth = 0;
			
			newWidth = panelWidth + _delta.width;
			appStoreActions.setCache(cacheKey, newWidth);
		},
		[panelWidth]
	);

	return [panelWidth, onResizeStop];
};
